import ColumnsTable from './ColumnsTable';

export default ColumnsTable;
